import React from "react";

import {
    MediaChooserBlock as LabUIValue,
    GoodcookMediaChooserBlock as Value,
} from "@reactivated";

import { ImageChooserBlock } from "@thelabnyc/thelabui/src/components/ImageChooserBlock";
import { MediaChooserBlock as LabUIMediaChooserBlock } from "@thelabnyc/thelabui/src/components/MediaChooserBlock";

import { VideoPlayerControls } from "../VideoPlayerControls";

interface Props {
    value: Value;
    wrapperAttrs?: React.HTMLAttributes<HTMLElement>;
    mediaAttrs?: React.HTMLAttributes<HTMLElement>;
    videoControlAttrs?: React.HTMLAttributes<HTMLElement>;
}

export const MediaChooserBlock = ({
    value,
    wrapperAttrs,
    mediaAttrs,
    videoControlAttrs,
}: Props) => {
    if (value.length === 0) return <></>;
    const media = value[0];

    if (media.type === "video")
        return media.value.video ? (
            <VideoPlayerControls
                value={media.value.video}
                wrapperAttrs={wrapperAttrs}
                attrs={mediaAttrs}
                controlAttrs={videoControlAttrs}
                playbackBehavior={media.value.playback_behavior}
            />
        ) : (
            <></>
        );

    if (media.type === "image")
        return (
            <ImageChooserBlock
                value={media.value}
                attrs={wrapperAttrs}
                imageAttrs={mediaAttrs}
            />
        );

    // At this point the labui media chooser should line up exactly with
    // Goodcook's, but TS was unhappy so we need a cast
    return (
        <LabUIMediaChooserBlock
            value={value as LabUIValue}
            attrs={wrapperAttrs}
        />
    );
};
